import { LoginService } from './../login.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';



@Component({
    selector: 'app-user-settings',
    templateUrl: './user-settings.component.html',
    styleUrls: ['./user-settings.component.scss'],
    standalone: false
})
export class UserSettingsComponent implements OnInit {
  page='exams'

  constructor(private router:Router,public ls: LoginService,) { 
    this.ls.loginMissing()
  }

  ngOnInit(): void {
 this.initFirstDoctor()
    
  }


  goToCalendar(){
    this.router.navigate(["/appointments"]);
  }

  setPage(page){
  this.page=page
  }

  initFirstDoctor(){
    if(Array.isArray(this.ls.clinicUsers) && !this.ls.doctor){
      this.ls.doctor=this.ls.clinicUsers[0]['UID']

    }
  }

}
